<template>
    <div>
        <rkm-form
            ref="Form"
            show-legend
        >
            <rkm-row class="flex-nowrap">

                <rkm-col class="flex-grow-1">
                    <rkm-form-input-autocomplete
                        :searchFields="localPaciente.autocompleteFieldsPaciente.paciente"
                        :repository="repositories.paciente"
                        v-model="paciente"
                        :text-field="(item) =>  item.cidadao.cns ? `${this.formatCns(item.cidadao.cns)} - ${item.cidadao.nome}` : item.cidadao.nome"
                        label="Paciente"
                        uppercase
                        @select="setListagem()"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-date-picker
                        label="Data de nascimento"
                        v-model="model.dataNascimento"
                        :max-date="data.form.dataAtual"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        label="Prontuário"
                        v-model="model.prontuario"
                        number
                    />
                </rkm-col>

                <rkm-col cols="auto">
                    <rkm-button
                        :label="false"
                        color="primary"
                        @click="$refs.Form.validate(search)"
                    >
                        Buscar
                    </rkm-button>

                    <rkm-button
                        :label="false"
                        @click="resetForm()"
                    >
                        Limpar
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <rkm-table
            v-if="itemsNotSave"
            :items="itemsNotSave"
            :fields="fields"
            hide-filters
            sort-by="pacienteNome"
        >

            <template v-slot:cell(pacienteNome)="{ item }">
                {{ item.pacienteNome }}

                <template v-if="item.pacienteNomeSocial">
                    <template v-if="item.pacientePreferenciaNomeId === enums.preferenciaNome.NOME_SOCIAL">
                        <strong>({{ item.pacienteNomeSocial }})</strong>
                    </template>

                    <template v-else>
                        ({{ item.pacienteNomeSocial }})
                    </template>
                </template>
            </template>

            <template v-slot:cell(telefones)="{ item }">

                <template v-if="item.telefones">
                    {{ handlePhone(item.telefones) }}
                </template>
                <template v-else>
                    NÃO INFORMADO
                </template>
            </template>

            <template v-slot:cell(actions)="{ item }">

                <rkm-button
                    small
                    title="Visualizar"
                    color="primary"
                    @click.stop="$router.push({ name: 'exame-laboratorial-exame-agendado-realizado-create', params: { id: item.pacienteId } })"
                >
                    <rkm-icon icon="search" />
                </rkm-button>
            </template>
        </rkm-table>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import { repository, error, object, formats, data, stringCase, printExameLaboratorial } from '@/mixins'

// Moment.
import moment from 'moment'

// Enums.
import statusAgendamento from '@/enums/exame-laboratorial/statusAgendamento'
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'

// Filters.
import format from '@/filters/formats'

export default {
    computed: {
        fields() {
            const fields = [
                {
                    key: "pacienteNome",
                    label: "Paciente",
                    sortable: true
                },
                {
                    key: "dataNascimento",
                    label: "Data de nascimento",
                    sortable: true
                },
                {
                    key: "nomeMae",
                    label: "Nome da mãe",
                    sortable: true
                },
                {
                    key: "municipio",
                    label: "Município - Estado",
                    sortable: true
                },
                {
                    key: "telefones",
                    label: "Telefones",
                    sortable: true
                },
                {
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min'
                }
            ]

            return fields
        },
        validations() {

            return {
                periodo: {
                    start: { required: true },
                    end: { required: true },
                },
            }
        },
    },
    created() {

        this.repositories = {
            exame: this.getConectaSusRepository('exameLaboratorial.exameAgendadoRealizado'),
            paciente: this.getConectaSusRepository('cadastro.sujeitoAtencao.paciente'),
            impressao: this.getConectaSusRepository('impressao.exameLaboratorial'),
        },

        this.load();
    },
    data() {
        return {
            model: {
                dataNascimento: null,
                prontuario: null,
                pacienteId: null,
                exameId: null,
                exames: null,
                grupos: null,
                agendamentoNumero: null,
                selecionados: true,
                periodo: {
                    start: null,
                    end: null,
                },
            },
            selecionados: false,
            agendamentoExame: [],
            itemsNotSave: null,
            saveAgendamento: {
                agendamentos: [],
            },
            paciente: null,
            localPaciente: {
                autocompleteFieldsPaciente: {
                    paciente: [
                        { key: 'cidadao.nome', searchable: true },
                    ],
                },
            },
            enums: {
                statusAgendamento,
                preferenciaNome
            },
        }
    },
    mixins: [repository, error, object, formats, data, printExameLaboratorial, stringCase],
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.model.periodo = this.data.form.periodo
        },
        save(){

            this.setLoading()

            this.repositories.exame.store(this.prepareData())
                .then(() => {

                    this.showSaveNotification()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading(this.$nextTick(() => this.resetForm())))
        },
        prepareData() {

            if (this.itemsNotSave && this.itemsNotSave.length > 0) {

                this.saveAgendamento.agendamentos = this.clone(this.itemsNotSave)

                const notSave = this.saveAgendamento

                return this.camelObjectKeysToSnakeRecursive(notSave)
            } else {

                const model = this.clone(this.data.model)

                return this.camelObjectKeysToSnakeRecursive(model)
            }
        },
        search() {

            this.setLoading()

            this.repositories.exame.list(this.getSearchParams())
                .then(({ data }) => {

                    this.itemsNotSave = data.model.agendamentos
                    this.selecionados = false
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getSearchParams() {

            const params = this.clone(this.model)

            if (this.paciente) {

                params.pacienteId = this.paciente.id
                params.pacienteNome = this.paciente.cidadao.nome
            }

            if (this.model.dataNascimento) {

                params.dataNascimento = moment(this.model.dataNascimento).format('YYYY-MM-DD')
            }

            return this.camelObjectKeysToSnakeRecursive(params)
        },
        resetForm() {

            this.paciente = null
            this.model.dataNascimento = null
            this.model.agendamentoNumero = null
            this.model.prontuario = null
            this.itemsNotSave = null

            this.$nextTick(() => this.$refs.Form.resetValidator())
        },
        handleListPrint() {

            this.setLoading()

            this.handleSelecionados()

            this.repositories.impressao.entregaExameList(this.getSearchParams())
                .then(response => {

                    const content = new Blob([response.data], {type: response.headers['content-type']})
                    const url = URL.createObjectURL(content)
                    const link = document.createElement('a')

                    link.href = url
                    link.target = '_blank'
                    link.click()
                    link.remove()
                })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
        },
        setListagem() {

            this.itemsNotSave = null
        },
        handlePrint(item) {

            this.setLoading()

            this.repositories.impressao.entregaExame({
                agendamento_id: item.agendamentoId,
                pertence_grupo: item.pertenceGrupo,
                exame_grupo_id: item.exameGrupoId,
                mapa_agrupado: item.mapaAgrupado ?? null,
                assinatura_profissional_id: item.assinaturaProfissionalId ?? null,
            })
            .then(response => {

                const content = new Blob([response.data], {type: response.headers['content-type']})
                const url = URL.createObjectURL(content)
                const link = document.createElement('a')

                link.href = url
                link.target = '_blank'
                link.click()
                link.remove()
            })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handlePhone(obj) {

            let telefones = ''

            Object.keys(obj).forEach(function(value, i) {

                if (i === 0) {
                    telefones = telefones.concat(obj[value])
                } else {
                    telefones = telefones.concat(`, ${obj[value]}`)
                }
            });

            return telefones
        }
    },
    filters: {
        ...format,
    },
    props: {
        data: { type: Object, required: true }
    },
}
</script>

<style scoped>
.table-td {
    background: #f1f1f1;
    padding: 0 10px;
    height: 35px;
    border-top: 1px solid #ccc;
    font-weight: 600;
}
.table-border-top {
    border-top: 0;
    height: 30px;
    padding: 0;
}
.table-width {
    width: 100%;
}
</style>